import { render, staticRenderFns } from "./EditSportModal.vue?vue&type=template&id=f5620a6a&"
import script from "./EditSportModal.vue?vue&type=script&lang=ts&"
export * from "./EditSportModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports